import {Component, forwardRef, Input, OnInit, ViewChild} from '@angular/core';
import { FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import {NgbDate, NgbDatepicker, NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-date-range-filter',
    templateUrl: './date-range-filter.component.html',
    styleUrls: ['./date-range-filter.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DateRangeFilterComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class DateRangeFilterComponent implements OnInit {
  @Input() filterForm: FormGroup;
  @Input() formControlDateStartName: string;
  @Input() formControlDateEndName: string;

  @ViewChild('dateRangePicker', { static: false }) datepicker!: NgbInputDatepicker;

  hoveredDate: NgbDate | null = null;

  isSelected = false;

  ngOnInit(): void {
    this.isSelected = this.filterForm.get(this.formControlDateStartName)?.value || this.filterForm.get(this.formControlDateEndName)?.value;
  }

  onDateSelection(date: NgbDate) {
		const dateStart = this.filterForm.get(this.formControlDateStartName)?.value;
		const dateEnd = this.filterForm.get(this.formControlDateEndName)?.value;

		if (!dateStart && !dateEnd) {
			this.filterForm.get(this.formControlDateStartName)?.setValue(date);
		} else if (dateStart && !dateEnd && date && date.after(dateStart)) {
			this.filterForm.get(this.formControlDateEndName)?.setValue(date);
      this.datepicker.close();
		} else {
			this.filterForm.get(this.formControlDateEndName)?.setValue(null);
			this.filterForm.get(this.formControlDateStartName)?.setValue(date);
		}

    this.isSelected = true;
	}

	onClearDate() {
		this.filterForm.get(this.formControlDateStartName)?.setValue(null);
		this.filterForm.get(this.formControlDateEndName)?.setValue(null);
		this.hoveredDate = null;
    	this.isSelected = false;
	}

	isHovered(date: NgbDate) {
		const dateStart = this.filterForm.get(this.formControlDateStartName)?.value;
		const dateEnd = this.filterForm.get(this.formControlDateEndName)?.value;
		return (
			dateStart && !dateEnd && this.hoveredDate && date.after(dateStart) && date.before(this.hoveredDate)
		);
	}

	isInside(date: NgbDate) {
		const dateStart = this.filterForm.get(this.formControlDateStartName)?.value;
		const dateEnd = this.filterForm.get(this.formControlDateEndName)?.value;
		return dateEnd && date.after(dateStart) && date.before(dateEnd);
	}

	isStart(date: NgbDate) {
		const dateStart = this.filterForm.get(this.formControlDateStartName)?.value;
		return date.equals(dateStart);
	}

	isEnd(date: NgbDate) {
		const dateEnd = this.filterForm.get(this.formControlDateEndName)?.value;
		return date.equals(dateEnd);
	}

	isRange(date: NgbDate) {
		const dateStart = this.filterForm.get(this.formControlDateStartName)?.value;
		const dateEnd = this.filterForm.get(this.formControlDateEndName)?.value;
		return (
			date.equals(dateStart) ||
			(dateEnd && date.equals(dateEnd)) ||
			this.isInside(date) ||
			this.isHovered(date)
		);
	}

  get dateRangeLabel(): string {
    const start: NgbDate | null = this.filterForm.get(this.formControlDateStartName)?.value;
    const end: NgbDate | null = this.filterForm.get(this.formControlDateEndName)?.value;

    if (!start || !end) return '';

    const format = (d: NgbDate) => `${d.day}. ${d.month}. ${d.year}`;

    return `${format(start)} – ${format(end)}`;
  }
}
